import {Injectable, OnDestroy} from '@angular/core';
import {CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {AppService} from 'app/services/app.service';
import {HelperService} from 'app/services/helper.service';
import {NavigationService} from 'app/services/navigation.service';
import {UserModelService} from 'app/models/user-model.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivateChild {
  appService: AppService;
  userModelService: UserModelService;
  helperService: HelperService;
  navigationService: NavigationService;
  router: Router;

  // @TODO merge two guards

  constructor(
    appService: AppService,
    helperService: HelperService,
    userModelService: UserModelService,
    navigationService: NavigationService,
    router: Router
  ) {
    this.appService = appService;
    this.userModelService = userModelService;
    this.helperService = helperService;
    this.navigationService = navigationService;
    this.router = router;
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    if (!this.appService.appReady) {
      await this.helperService.wait(() => this.appService.appReady === true);
    }

    if (this.userModelService.isLogin()) {
      this.navigationService.entryUrl = null;
      this.navigationService.goAfterLogin(true);
    }

    return !this.userModelService.isLogin();
  }

}
